import { lazy } from 'react';

const CheckupPage = lazy(() => import('../pages/Checkup.page'));
const AddCheckupPage = lazy(() => import('../pages/AddCheckup.page'));
const ViewPatientPage = lazy(() => import('@/features/patient-profile/Viewpatient.page'));

export const CheckupRoutes = [
    { path: 'checkup', element: <CheckupPage /> },
    { path: 'checkup/add/:id', element: <AddCheckupPage /> },
    {
        path: 'checkup/:id',
        element: <ViewPatientPage />,
        layout: 'default',
        isAuthReq: true,
    },
];
